import { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAddAssignmentMutation } from "../../../../features/assignment/assignmentApi";
import { useGetVideosQuery } from "../../../../features/videos/videosApi";
import SelectList from "../../../ui/SelectList";
import MessageToast from "../../../ui/MessageToast";
import Error from "../../../ui/Error";

export default function AddAssignment() {
	const [title, setTitle] = useState("");
	const [video_id, setVideoId] = useState("");
	const [totalMark, setTotalMark] = useState("");

	const {
		data: videos,
		isSuccess: isGetVideosQuerySuccess,
		isError: isGetVideosError,
	} = useGetVideosQuery() || {};

	let videosSelectOptions = [];
	if (isGetVideosQuerySuccess) {
		videosSelectOptions = videos.map((video) => ({
			id: video.id,
			text: video.title,
		}));
	}

	const [
		addAssignment,
		{
			isLoading,
			isError: isAddAssignmentError,
			isSuccess: isAddAssignmentSuccess,
		},
	] = useAddAssignmentMutation() || [];

	const navigate = useNavigate();

	useEffect(() => {
		if (isAddAssignmentSuccess) {
			navigate("/admin/assignments");
		}
	}, [isAddAssignmentSuccess, navigate]);

	const handleFormSubmit = (e) => {
		e.preventDefault();
		const videoTitle = videos.find((v) => v.id == video_id)?.title;

		let assignmentData = {
			title,
			video_id: Number(video_id),
			video_title: videoTitle,
			totalMark,
		};

		addAssignment(assignmentData);
	};

	return (
		<section className="py-6 bg-primary place-items-center">
			{/* Add assignment is only possible when videos are available */}
			{isGetVideosQuerySuccess && videos?.length > 0 ? (
				<div className="mx-auto max-w-5xl px-5 lg:px-0">
					<div>
						<h2 className="mt-6 text-center text-3xl font-extrabold text-slate-100">
							Add Assignment
						</h2>
					</div>
					<form
						onSubmit={handleFormSubmit}
						className="mt-8 space-y-6"
					>
						<div className="rounded-md shadow-sm ">
							<div>
								<label className="text-sm font-bold">
									Title:
								</label>
								<input
									value={title}
									onChange={(e) => setTitle(e.target.value)}
									id="name"
									name="name"
									type="name"
									autoComplete="name"
									required
									className="login-input rounded-t-md"
									placeholder="Assignment title"
								/>
							</div>
							<div className="mt-4">
								<label className="text-sm font-bold">
									Select video to attach:
								</label>
								<SelectList
									options={videosSelectOptions}
									value={video_id}
									setValue={setVideoId}
									defaultText="Select video"
									className="login-input rounded-t-md"
									required
								/>
							</div>
							<div className="mt-4">
								<label className="text-sm font-bold">
									Total mark:
								</label>
								<input
									value={totalMark}
									onChange={(e) =>
										setTotalMark(e.target.value)
									}
									id="assignment-mark"
									name="assignment-mark"
									type="number"
									autoComplete="assignment-mark"
									required
									className="login-input"
									placeholder="Assignment mark"
								/>
							</div>
						</div>

						<div className="flex justify-center">
							<button
								disabled={isLoading || isGetVideosError}
								type="submit"
								className="group relative flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
							>
								Add
							</button>
						</div>
					</form>
				</div>
			) : (
				// When no videos found, can not add assignment
				<>
					<Error message="No videos found!, add videos first to attach assignment" />
					<Link to="/admin/videos">Go to videos page</Link>
				</>
			)}

			{/* Show result wise success of fail message */}
			{isAddAssignmentSuccess && (
				<MessageToast message="Assignment create success" />
			)}

			{isAddAssignmentError && (
				<MessageToast
					message="Assignment create failed!"
					type="error"
				/>
			)}

			{isGetVideosError && (
				<MessageToast message="Error getting videos, so can't add assignment now" />
			)}
		</section>
	);
}
